module.exports = __webpack_public_path__ + "media/src/images/zu_04before_start02-5376c65c2fc5319b692df05e3eec2963.jpg";